import {
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    DoughnutController,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    PieController,
    PointElement,
    Tooltip
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'

// Registered once, globally, for every Chart.js chart in Helm (the migrated MetricSparkline
// and the dashboard MetricWidget) rather than per-component - avoids re-registering controllers
// on every chart mount.
Chart.register(
    BarController,
    LineController,
    PieController,
    DoughnutController,
    ArcElement,
    BarElement,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Legend,
    Tooltip,
    annotationPlugin
)
